<div mat-dialog-title>
  <span class="title dialog-title" i18n>Облицовка</span>
  <button mat-button class="mat-icon-button" [mat-dialog-close] aria-label="Close dialog">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-divider> </mat-divider>

<div mat-dialog-content class="no-padding overflow-hidden">
  <csl-material-base-butts
    (selectionChange)="selectedButt = $event"
    [filterByThickness]="data.filterByThickness"
    [panelThickness]="data.panelThickness"
    [dataProvider]="data.dataProvider"
    [showQuantityInStock]="data.showQuantityInStock"></csl-material-base-butts>
</div>

<div mat-dialog-actions>
  <button mat-raised-button data-testid="materialBaseButtsOkButton" class="mat-accent" (click)="saveAndClose()" i18n
    >ОК</button
  >
  <button mat-button [mat-dialog-close] i18n>ОТМЕНА</button>
</div>
